import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import {constants} from '../../config/constants';
import './styles.css';

function Index() {

  const {
    allmenu
  } = useSelector((state) => state.initLoad);


  return (
    <div
      style={{
       // backgroundImage: `url(${require('./assets/splash_bk.jpg')})`,
        backgroundSize: 'cover',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black',
      }}
    >
      <img
        className={'logo'}
        src={require('./assets/franciscas-logo_White.png')}
        alt="Logo"
      />

      <div style={{
        position: 'absolute',
        bottom: 0,
        textAlign: 'center',
        backgroundColor: 'black',
        width: '100%'
      }}>
        <p style={{color: 'white'}}>Powered by boostyourmenu.com</p>
      </div>
    </div>
  );
}

export default Index;
